import { useParams } from 'react-router'

import '../style.css'
const ViewSubtitle = (props) => {
  const { id } = useParams()
  return (
    <div
      className='tl-employee-content-wrapper editor-data-styles sun-editor-editable h-100 scrollbar'
      style={{ padding: '20px' }}
    >
      The content below contains information related to:
      <span className='subtitle-text-desc'>
        {props.content.find((item) => item.id === parseInt(id))
          ? props.content.find((item) => item.id === parseInt(id)).title
          : null}
      </span>
    </div>
  )
}

export default ViewSubtitle
